import { HTTPINPUTTYPE } from '../../../../../../../enums/HTTPINPUTTYPE.js';
import INPUT from '../../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const inputPasswordAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['value', ''],
    ['placeholder', ''],
    ['required', true],
    ['type', HTTPINPUTTYPE.PASSWORD]
]);
export const inputPasswordData = makeDataStruct([]);
export const inputPasswordModel = makeStruct([
    ['attributes', inputPasswordAttr],
    ['data', inputPasswordData]
]);
// Simplified Model
export function inputPassword(name, className, value, placeholder) {
    return {
        attributes: inputPasswordAttr(name, className, value, placeholder),
        data: inputPasswordData()
    };
}
// Class
export default class INPUTPASSWORD extends INPUT {
    constructor(node, model) {
        super(node, model);
    }
}
